export const TodoCreateQuickDialogCombo = "shift + t";
